import React from 'react'

import { ZariContext } from '_zari/context'
import { Divider, Col, Row, Button } from '_zari/core'

import { DownloadAxiosFile, ZrSwal } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const ReporteTxtSection = ({ tablaRef }) => {
  const __zariContext = React.useContext(ZariContext)

  const [flagGenerarNuevoCorrelativo, setFlagGenerarNuevoCorrelativo] = React.useState(true)

  const descargarTxt = React.useCallback(
    ({ flagGenerarNuevoCorrelativo }) => {
      __zariContext.loader.open('Descargando excel reporte de detracciones')

      AsientoContableService.descargarReporteTxtDetracciones({ flagGenerarNuevoCorrelativo })
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
          __zariContext.toast('success', 'Reporte descargado.')

          if (flagGenerarNuevoCorrelativo) {
            if (tablaRef.current && tablaRef.current.reload) {
              tablaRef.current.reload()
              setFlagGenerarNuevoCorrelativo(false)
            }
          }
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
        })
    },
    [__zariContext, tablaRef]
  )

  const onClickDescargarTxt = React.useCallback(() => {
    if (flagGenerarNuevoCorrelativo) {
      ZrSwal.showAlert({
        mensaje: 'Seguro que desea generar un nuevo correlativo?',
        showCerrar: true,
        tipo: 'warning',
        onSuccess: () => {
          descargarTxt({ flagGenerarNuevoCorrelativo: true })
        }
      })
    } else {
      descargarTxt({ flagGenerarNuevoCorrelativo: false })
    }
  }, [descargarTxt, flagGenerarNuevoCorrelativo])

  return (
    <>
      <Divider title='Reportes Txt' />
      <Row className='zari-slim-form'>
        <Col md={12}>
          <FormGroups.FlagGenerarNuevoCorrelativoFormGroup
            checked={flagGenerarNuevoCorrelativo}
            onChange={() => setFlagGenerarNuevoCorrelativo(prev => !prev)}
          />
        </Col>
      </Row>
      <Row className='mb-2'>
        <Col md={12}>
          <Button outline tiny onClick={onClickDescargarTxt}>
            Descargar Txt
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default React.memo(ReporteTxtSection)
